export default __webpack_public_path__ + "static/media/Powerumzug.77a4095d.jpg";